const common = {
  Loading: "Wird geladen",
  signUp: "Anmelden",
  login: "Anmeldung",
  logout: "Abmelden",
  email: "E-Mail",
  emailFormatErrorTips: "Das E-Mail-Format ist falsch",
  emailDifferentTips: "Bitte geben Sie in beide Felder die gleiche E-Mail ein.",
  emailRegisteredTips: "Die E-Mail wurde registriert, bitte wählen Sie eine andere E-Mail.",
  password: "Passwort",
  passwordFormatErrorTips: "Das Passwort muss 8-50 Zeichen lang sein und Zahlen, Groß- und Kleinbuchstaben enthalten.",
  passwordDifferentTips: "Bitte geben Sie in beide Felder das gleiche Passwort ein.",
  verificationCode: "Verifizierungs-Code",
  verificationCodeErrorTips: "Falscher Bestätigungscode",
  confirm: "Bestätigen Sie",
  cancel: "Abbrechen",
  submit: "Absenden",
  confirmEmail: "Bestätigen Sie E-Mail",
  formEmptyErrorTips: "Kann hier nicht leer sein.",
  country: "Land/Region",
  birthday: "Geburtstag",
  anonymous: "Anonym",
  name: "Name",
  nameFormatErrorTips: "Der Benutzername sollte nicht länger als 50 Zeichen sein und keine Sonderzeichen enthalten.",
  okBtn: "OK",
  serverErrorTips: "Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
  updateSuccessTips: "Erfolgreich modifiziert",
  authorizationExpiredErrorTips: "Die Berechtigung ist abgelaufen, bitte melden Sie sich erneut an.",
  requestFrequentlyErrorTips: "Es wurden zu viele gleiche Anfragen in einem kurzen Zeitraum gestellt, bitte versuchen Sie es später noch einmal.",
};

export default common;
